import { Component, OnInit, NgZone } from '@angular/core';
import { RequestOptions, RequestMethod, Response, RequestOptionsArgs, Http, Headers, ResponseContentType } from '@angular/http';
import { Observable, Subscription } from 'rxjs/Rx';
import { StaticLed, FadeLED } from '../../Models/LedModels';

@Component({
  selector: 'app-main',
  template: require('.//main.component.html'),
  styles: [require('.//main.component.css')]
})
export class mainComponent implements OnInit {

  private IsStaticPlaying: boolean = false;
  private IsFadedPlaying: boolean = false;

  private CurrentStaticLed: StaticLed = new StaticLed();
  private CurrentFadeLed: FadeLED = new FadeLED();

  private SelectedStaticIndex: number;
  private SelectedFadedIndex: number;
  private StaticLedsCode: string = "";
  private FadedLedsCode: string;
  private DoLoopStatic: boolean = false;
  private DoLoopFaded: boolean = false;

  private StaticLeds: StaticLed[];
  private FadedLeds: FadeLED[];

  private test: boolean;

  constructor(private http: Http) {
    this.StaticLeds = [];
    this.FadedLeds = [];
  }

  updateInterval: number = 1000;

  ngOnInit() {
    this.CurrentStaticLed.Delay = 100;
    this.CurrentFadeLed.Delay = 100;
  }

  timer: Observable<number>;
  timerSubscription: Subscription;
  /*
    updateRefreshInterval() {
      this.updateInterval = this.updateInterval < 100 ? 100 : this.updateInterval;
  
      this.timer = Observable.timer(0, this.updateInterval);
  
      if (this.timerSubscription != undefined)
        this.timerSubscription.unsubscribe();
  
      this.timerSubscription = this.timer.subscribe(t => {
      }
      );
    }
  */

  AddFadedLed() {
    if (this.IsFadedPlaying)
      return;

    this.FadedLeds.push(jQuery.extend(true, {}, this.CurrentFadeLed));
    this.FadedArrayChanged();
  }

  AddStaticLed() {
    if (this.IsStaticPlaying)
      return;

    this.StaticLeds.push(jQuery.extend(true, {}, this.CurrentStaticLed));
    this.StaticArrayChanged();
  }

  MoveStaticUp() {
    if (this.IsStaticPlaying)
      return;

    if (this.SelectedStaticIndex == undefined || this.SelectedStaticIndex == 0 || this.StaticLeds == undefined || this.StaticLeds.length == 0)
      return;

    let x = this.StaticLeds[this.SelectedStaticIndex - 1];
    this.StaticLeds[this.SelectedStaticIndex - 1] = this.StaticLeds[this.SelectedStaticIndex];
    this.StaticLeds[this.SelectedStaticIndex] = x;
    this.SelectedStaticIndex--;
    this.StaticArrayChanged();
  }

  MoveFadedUp() {
    if (this.IsFadedPlaying)
      return;

    if (this.SelectedFadedIndex == undefined || this.SelectedFadedIndex == 0 || this.FadedLeds == undefined || this.FadedLeds.length == 0)
      return;

    let x = this.FadedLeds[this.SelectedFadedIndex - 1];
    this.FadedLeds[this.SelectedFadedIndex - 1] = this.FadedLeds[this.SelectedFadedIndex];
    this.FadedLeds[this.SelectedFadedIndex] = x;
    this.SelectedFadedIndex--;
    this.FadedArrayChanged();
  }

  MoveStaticDown() {
    if (this.IsStaticPlaying)
      return;

    if (this.SelectedStaticIndex == undefined || this.StaticLeds == undefined || this.StaticLeds.length == 0 || this.SelectedStaticIndex == this.StaticLeds.length - 1)
      return;

    let x = this.StaticLeds[this.SelectedStaticIndex + 1];
    this.StaticLeds[this.SelectedStaticIndex + 1] = this.StaticLeds[this.SelectedStaticIndex];
    this.StaticLeds[this.SelectedStaticIndex] = x;
    this.SelectedStaticIndex++;
    this.StaticArrayChanged();
  }

  MoveFadedDown() {
    if (this.IsFadedPlaying)
      return;

    if (this.SelectedFadedIndex == undefined || this.FadedLeds == undefined || this.FadedLeds.length == 0 || this.SelectedFadedIndex == this.FadedLeds.length - 1)
      return;

    let x = this.FadedLeds[this.SelectedFadedIndex + 1];
    this.FadedLeds[this.SelectedFadedIndex + 1] = this.FadedLeds[this.SelectedFadedIndex];
    this.FadedLeds[this.SelectedFadedIndex] = x;
    this.SelectedFadedIndex++;
    this.FadedArrayChanged();
  }

  SelectedStaticIndexChanged() {
    this.CurrentStaticLed = jQuery.extend(true, {}, this.StaticLeds[this.SelectedStaticIndex]);
  }

  SelectedFadedIndexChanged() {
    this.CurrentFadeLed = jQuery.extend(true, {}, this.FadedLeds[this.SelectedFadedIndex]);
  }

  RemoveSelectedStatic() {
    if (this.IsStaticPlaying || this.SelectedStaticIndex == undefined)
      return;

    this.StaticLeds.splice(this.SelectedStaticIndex, 1);
    if (this.StaticLeds.length != 0)
      this.SelectedStaticIndex = this.SelectedStaticIndex > this.StaticLeds.length - 1 ? this.StaticLeds.length - 1 : this.SelectedStaticIndex;
    else
      this.SelectedStaticIndex = undefined;

    this.StaticArrayChanged();
  }

  RemoveSelectedFade() {
    if (this.IsFadedPlaying || this.SelectedFadedIndex == undefined)
      return;

    this.FadedLeds.splice(this.SelectedFadedIndex, 1);
    if (this.FadedLeds.length != 0)
      this.SelectedFadedIndex = this.SelectedFadedIndex > this.FadedLeds.length - 1 ? this.FadedLeds.length - 1 : this.SelectedFadedIndex;
    else
      this.SelectedFadedIndex = undefined;

    this.FadedArrayChanged();
  }

  SaveToStatic() {
    if (this.IsStaticPlaying)
      return;

    this.StaticLeds[this.SelectedStaticIndex] = jQuery.extend(true, {}, this.CurrentStaticLed);
    this.StaticArrayChanged();
  }

  SaveToFaded() {
    if (this.IsFadedPlaying)
      return;

    this.FadedLeds[this.SelectedFadedIndex] = jQuery.extend(true, {}, this.CurrentFadeLed);
    this.FadedArrayChanged();
  }

  StaticArrayChanged() {
    this.GenerateStaticCode();
  }

  ConvertStaticCode() {
    let lines = this.StaticLedsCode.split("},");

    this.StaticLeds = [];
    for (let i = 0; i < lines.length; i++) {
      let led = new StaticLed;
      let line = lines[i];
      line = line.replace(" ", "");
      line = line.replace("{", "");
      line = line.replace("}", "");

      let components = line.split(",");
      let ledString = components[0];
      led.LED1 = ledString[ledString.length - 1] == "1";
      led.LED2 = ledString[ledString.length - 2] == "1";
      led.LED3 = ledString[ledString.length - 3] == "1";
      led.LED4 = ledString[ledString.length - 4] == "1";
      led.LED5 = ledString[ledString.length - 5] == "1";
      led.Delay = parseInt(components[1]);

      this.StaticLeds.push(led);
    }
  }

  ConvertFadedCode() {
    let lines = this.FadedLedsCode.split("},");

    this.FadedLeds = [];
    for (let i = 0; i < lines.length; i++) {
      let led = new FadeLED;
      let line = lines[i];
      line = line.split(" ").join("");
      line = line.split("{").join("");
      line = line.split("}").join("");

      let components = line.split(",");
      led.LED1Fade = parseInt(components[0]);
      led.LED2Fade = parseInt(components[2]);
      led.LED3Fade = parseInt(components[4]);
      led.LED4Fade = parseInt(components[6]);
      led.LED5Fade = parseInt(components[8]);
      led.Delay = parseInt(components[10])

      this.FadedLeds.push(led);
    }
  }

  FadedArrayChanged() {
    this.GenerateFadedCode();
  }

  Frequency: number = 100;
  Time: number = 1000 / this.Frequency;
  UpscaleFactor: number = 250;
  GenerateFadedCode() {
    let lastLed = new FadeLED();
    this.FadedLedsCode = "{ ";
    for (let i = 0; i < this.FadedLeds.length; i++) {

      let led = jQuery.extend(true, {}, this.FadedLeds[i]);
      led.LED1Fade = 255.0 * this.Time / (1.0 / Math.abs(lastLed.LED1Fade - led.LED1Fade) * led.Delay);
      led.LED2Fade = 255.0 * this.Time / (1.0 / Math.abs(lastLed.LED2Fade - led.LED2Fade) * led.Delay);
      led.LED3Fade = 255.0 * this.Time / (1.0 / Math.abs(lastLed.LED3Fade - led.LED3Fade) * led.Delay);
      led.LED4Fade = 255.0 * this.Time / (1.0 / Math.abs(lastLed.LED4Fade - led.LED4Fade) * led.Delay);
      led.LED5Fade = 255.0 * this.Time / (1.0 / Math.abs(lastLed.LED5Fade - led.LED5Fade) * led.Delay);

      led.LED1Fade = parseInt(this.Constrain(led.LED1Fade, 0, 255 * this.UpscaleFactor).toString());
      led.LED2Fade = parseInt(this.Constrain(led.LED2Fade, 0, 255 * this.UpscaleFactor).toString());
      led.LED3Fade = parseInt(this.Constrain(led.LED3Fade, 0, 255 * this.UpscaleFactor).toString());
      led.LED4Fade = parseInt(this.Constrain(led.LED4Fade, 0, 255 * this.UpscaleFactor).toString());
      led.LED5Fade = parseInt(this.Constrain(led.LED5Fade, 0, 255 * this.UpscaleFactor).toString());

      this.FadedLedsCode += "{ " + this.FadedLeds[i].LED1Fade + ", " + led.LED1Fade + ", " + this.FadedLeds[i].LED2Fade + ", " + led.LED2Fade + ", " + this.FadedLeds[i].LED3Fade + ", " + led.LED3Fade + ", " + this.FadedLeds[i].LED4Fade + ", " + led.LED4Fade + ", " + this.FadedLeds[i].LED5Fade + ", " + led.LED5Fade + ", " + led.Delay + " }" + (i == this.FadedLeds.length - 1 ? "" : ", ");
      if(this.FadedLedsCode.indexOf("NaN") != -1){
        console.log("NAN");
      }
      lastLed = this.FadedLeds[i];
    }
    this.FadedLedsCode += " }";
  }

  Constrain(value: number, min: number, max: number, def: number = 255): number {
    if (min == undefined || max == undefined || min > max)
      return 0;

    if (value == undefined || isNaN(value))
      return def;

    if (value > max)
      return max;

    if (value < min)
      return min;

    return value;
  }

  GenerateStaticCode() {
    this.StaticLedsCode = "{ ";

    for (let i = 0; i < this.StaticLeds.length; i++) {
      let led = this.StaticLeds[i];
      this.StaticLedsCode += "{ 0b000" + (led.LED5 == true ? "1" : "0") + (led.LED4 == true ? "1" : "0") + (led.LED3 == true ? "1" : "0") + (led.LED2 == true ? "1" : "0") + (led.LED1 == true ? "1" : "0") + "," + led.Delay + " }" + (i == this.StaticLeds.length - 1 ? "" : ", ");
    }
    this.StaticLedsCode += " }";
  }

  private StaticTimers: number[] = [];
  PlayStatic() {
    this.ClearStaticTimers();
    if (this.StaticLeds == undefined || this.StaticLeds.length == 0)
      return;

    this.IsStaticPlaying = true;
    let totalDelay = 0;
    for (let i = 0; i < this.StaticLeds.length; i++) {
      this.StaticTimers.push(setTimeout((() => {
        this.CurrentStaticLed = jQuery.extend(true, {}, this.StaticLeds[i]);
        if (this.DoLoopStatic == false)
          this.IsStaticPlaying = !(this.StaticLeds.length - 1 == (i));
      }).bind(this), totalDelay));
      totalDelay += parseInt(this.StaticLeds[i].Delay.toString());
    };

    if (this.DoLoopStatic)
      this.StaticTimers.push(setTimeout((() => {
        this.PlayStatic();
      }).bind(this), totalDelay));
  }

  private FadedTimers: number[] = [];
  PlayFaded() {
    this.ClearFadedTimers();
    if (this.FadedLeds == undefined || this.FadedLeds.length == 0)
      return;

    this.IsFadedPlaying = true;
    let totalDelay = 0;
    for (let i = 0; i < this.FadedLeds.length; i++) {
      this.FadedTimers.push(setTimeout((() => {
        this.CurrentFadeLed = jQuery.extend(true, {}, this.FadedLeds[i]);
        if (this.DoLoopFaded == false)
          this.IsFadedPlaying = !(this.FadedLeds.length - 1 == i);
      }).bind(this), totalDelay));
      totalDelay += parseInt(this.FadedLeds[i].Delay.toString());
    };

    if (this.DoLoopFaded)
      this.FadedTimers.push(setTimeout((() => {
        this.PlayFaded();
      }).bind(this), totalDelay));
  }

  StartStopStaticPlay() {
    if (this.IsStaticPlaying)
      this.StopStatic();
    else
      this.PlayStatic();
  }

  StartStopFadedPlay() {
    if (this.IsFadedPlaying)
      this.StopFaded();
    else
      this.PlayFaded();
  }

  StopStatic() {
    this.ClearStaticTimers();
    this.IsStaticPlaying = false;
  }

  StopFaded() {
    this.ClearFadedTimers();
    this.IsFadedPlaying = false;
  }

  ClearStaticTimers() {
    for (let i = 0; i < this.StaticTimers.length; i++) {
      clearTimeout(this.StaticTimers[i]);
    }
    this.StaticTimers = [];
  }

  ClearFadedTimers() {
    for (let i = 0; i < this.FadedTimers.length; i++) {
      clearTimeout(this.FadedTimers[i]);
    }
    this.FadedTimers = [];
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/Components/main/main.component.ts
 **/